import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Warn-Dialog: Alles zurücksetzen – bestätigen bei laufender Uhr oder vorhandenen Daten.
 */
function ResetConfirmDialog({
  open,
  isRunning,
  currentTimeLabel,
  measurementsCount,
  isSessionNotUploaded,
  onConfirm,
  onCancel
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>⚠️ {t('dialog.reset_confirm.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('dialog.reset_confirm.message')}
          </p>
          <div className="edit-info">
            {isRunning && currentTimeLabel != null && (
              <div style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#ef4444' }}>
                ⚠️ <strong>{t('dialog.reset_confirm.running')}</strong> {currentTimeLabel}
              </div>
            )}
            {measurementsCount > 0 && (
              <div style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#ef4444' }}>
                ⚠️ <strong>{t('dialog.reset_confirm.measurements_present')}</strong> {t('dialog.reset_confirm.measurements_deleted', { count: measurementsCount })}
              </div>
            )}
            {isSessionNotUploaded && (
              <div style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#f59e0b' }}>
                ⚠️ <strong>{t('dialog.reset_confirm.not_uploaded')}</strong> {t('dialog.reset_confirm.not_uploaded_info')}
              </div>
            )}
            <div style={{ marginTop: '12px', fontSize: '0.9rem', color: '#ef4444', fontWeight: 'bold' }}>
              {t('dialog.reset_confirm.final_warning')}
            </div>
          </div>
        </div>
        <div className="edit-actions">
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
          <button className="btn btn-danger" onClick={onConfirm} type="button">
            {t('dialog.reset_confirm.confirm_button')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResetConfirmDialog;
